export default __webpack_public_path__ + "static/media/search.e911649f.svg";